export default "__VITE_ASSET__CYqcJ91U__"